module.exports = __webpack_public_path__ + "img/banner4.e7cedb9.png";